/* eslint-disable */
// We disable eslint in this file because we have to set things up in the format the tracking service expects, which often doesn't pass our linter.

const gtmNames = {
  'com': 'GTM-N6Z3FD6'
}

export default {
  strict: true,
  state: {
    isLoaded: false
  },
  mutations: {
    INITIALIZE (state, data) {
      try {
        gtm(window, document, 'script', 'dataLayer', data.gtmID)
        state.isLoaded = true
      } catch (e) {
        console.log('tracking: initialize failed:', e)
      }
    }
  },

  actions: {
    initializeTracking ({ commit, state, getters }) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring init')
        return
      }
      let data = {
        gtmID: getters.gtmID
      }
      commit('INITIALIZE', data)
    },

    trackPageLoad ({ commit, state, dispatch }, page) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring page load')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }
    },

    trackViewPosters ({ commit, state, getters, dispatch }, data) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring add to cart')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }

      let impressions = []
      const ecomm_prodid = []
      const ecomm_pname = []
      data.posters.forEach(function (poster, key) {
        impressions.push({
          name: poster.name,
          id: poster.baseID + '-' + poster.colors[0].ID + '-' + getters.posterPresentationID,
          price: poster.prices[getters.currency.currency] / 100,
          brand: poster.artist,
          category: 'Posters',
          variant: poster.colors[0].name,
          list: data.list, // TODO! dataLayer just grows
          position: key + 1
        })
        ecomm_prodid.push(poster.baseID + '-' + poster.colors[0].ID + '-' + getters.posterPresentationID)
        ecomm_pname.push(poster.name)
      })

      let dataLayerObj = {
        event: 'ecommerce',
        ecommerce: {
          currencyCode: getters.currency.currency,
          impressions
        },
        ecomm_pagetype: data.list === 'inspiration' ? 'home' : 'category',
        ecomm_prodid,
        ecomm_pname
      }
      if (dataLayerObj.ecomm_pagetype === 'category') {
        dataLayerObj.ecomm_pcat = ['Posters']
      }

      dataLayer.push(dataLayerObj)
    },

    trackViewFrames ({ commit, state, getters, dispatch }, data) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring add to cart')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }

      let impressions = []
      const ecomm_prodid = []
      const ecomm_pname = []
      data.frames.forEach(function (frame, key) {
        impressions.push({
          name: frame.name,
          id: frame.key,
          price: frame.prices[getters.currency.currency] / 100,
          brand: frame.brand,
          category: 'Frames and Hangers',
          variant: frame.variant,
          list: data.list,
          position: key + 1
        })
        ecomm_prodid.push(frame.key)
        ecomm_pname.push(frame.name)
      })

      let dataLayerObj = {
        event: 'ecommerce',
        ecommerce: {
          currencyCode: getters.currency.currency,
          impressions
        },
        ecomm_pagetype: 'category',
        ecomm_pcat: 'Frames and Hangers',
        ecomm_prodid,
        ecomm_pname
      }

      dataLayer.push(dataLayerObj)
    },

    trackPosterClick ({ commit, state, getters, dispatch }, data) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring view product')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }

      dataLayer.push({
        event: 'productClick',
        ecommerce: {
          currencyCode: getters.currency.currency,
          click: {
            actionField: {'list': data.list},
            products: [{
              name: data.poster.name,
              id: data.poster.baseID + '-' + data.color.ID + '-' + getters.posterPresentationID,
              price: data.poster.prices[getters.currency.currency] / 100,
              brand: data.poster.artist,
              category: 'Posters',
              variant: data.color.name,
              position: data.position
            }]
          }
        }
      })
    },

    trackPosterView ({ commit, state, getters, dispatch }, data) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring view product')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }

      dataLayer.push({
        // event: 'ecommerce', // changed because of the FB Pixel
        event: 'viewProduct',
        ecommerce: {
          currencyCode: getters.currency.currency,
          detail: {
            actionField: {'list': data.list},
            products: [{
              name: data.poster.name,
              id: data.poster.baseID + '-' + data.color.ID + '-' + getters.posterPresentationID,
              price: data.poster.prices[getters.currency.currency] / 100,
              brand: data.poster.artist,
              category: 'Posters',
              variant: data.color.name,
              position: data.position
            }]
          }
        },
        ecomm_pagetype: 'product', //set the value
        ecomm_pcat: ['Posters'],
        ecomm_prodid: [data.poster.baseID + '-' + data.color.ID + '-' + getters.posterPresentationID],
        ecomm_pname: [data.poster.name],
      })
    },

    trackAddToCart ({ commit, state, getters, dispatch }, item) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring add to cart')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }

      let category = 'Posters'
      if (item.product) {
        switch(item.product.category) {
          case 'poster':
            category = 'Posters'
            break
          case 'giftCard':
            category = 'Gift Cards'
            break
          case 'frame':
          case 'hanger':
            category = 'Frames and Hangers'
            break
          default:
            category = 'Other'
        }
      }
      let variant = item.product ? item.product.variant : ''
      if (category === 'Posters') {
        variant = item.options ? item.options.color : item.color
      }

      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: item.price.currency,
          add: {
            actionField: { 'list': item.list }, // TODO! is this needed?
            products: [ {
              name: item.product ? item.product.name : item.productName,
              id: item.product ? item.product.id : item.id,
              price: item.price.amount / 100,
              brand: item.product ? item.product.brand : getters.postersMetaData[item.productIdentifier].artist,
              category: category,
              variant: variant,
              quantity: 1, // TODO! what if more are added?
              position: item.position // TODO! is this needed?
            } ]
          }
        }
      })
    },

    trackRemoveFromCart ({ commit, state, getters, dispatch }, data) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring add to cart')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }

      let category = 'Posters'
      if (data.product) {
        switch(data.product.category) {
          case 'poster':
            category = 'Posters'
            break
          case 'giftCard':
            category = 'Gift Cards'
            break
          case 'frame':
          case 'hanger':
            category = 'Frames and Hangers'
            break
          default:
            category = 'Other'
        }
      }

      dataLayer.push({
        event: 'removeFromCart',
        ecommerce: {
          currencyCode: getters.currency.currency,
          remove: {
            actionField: { 'list': data.list }, // TODO! is this needed?
            products: [{
              name: data.product.product ? data.product.product.name : data.product.productName,
              id: data.product.product ? data.product.product.id : data.product.id,
              price: data.product.price.amount / 100,
              brand: data.product.product ? data.product.product.brand : getters.postersMetaData[data.product.productIdentifier].artist,
              category: category,
              variant: data.product.options ? data.product.options.color : data.product.color,
              quantity: data.quantity,
              position: data.product.position // TODO! is this needed?
            }]
          }
        }
      })
    },

    trackCheckout ({ commit, state, getters, dispatch }, cart) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring add to cart')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }

      let products = []
      const ecomm_prodid = []
      const ecomm_pname = []
      const ecomm_pcat = []
      const ecomm_pvalue = []
      let ecomm_totalvalue = 0
      cart.forEach(function (item) {
        let category = 'Posters'
        if (item.product) {
          switch(item.product.category) {
            case 'poster':
              category = 'Posters'
              break
            case 'giftCard':
              category = 'Gift Cards'
              break
            case 'frame':
            case 'hanger':
              category = 'Frames and Hangers'
              break
            default:
              category = 'Other'
          }
        }
        let variant = item.product ? item.product.variant : ''
        if (category === 'Posters') {
          variant = item.options ? item.options.color : item.color
        }
        const productObj = {
          name: item.product ? item.product.name : item.productName,
          id: item.product ? item.product.id : item.id,
          price: item.price.amount / 100,
          brand: item.product ? item.product.brand : getters.postersMetaData[item.productIdentifier].artist,
          category: category,
          variant: variant,
          quantity: item.count
        }
        products.push(productObj)
        ecomm_prodid.push(productObj.id)
        ecomm_pname.push(productObj.name)
        if (ecomm_pcat.indexOf(productObj.category) < 0) {
          ecomm_pcat.push(category)
        }
        ecomm_pvalue.push(productObj.price)
        ecomm_totalvalue += productObj.price * productObj.quantity
      })

      dataLayer.push({
        event: 'checkout',
        ecommerce: {
          currencyCode: getters.currency.currency,
          checkout: {
            actionField: { step: 1 },
            products
          }
        },
        ecomm_pagetype: 'cart',
        ecomm_prodid,
        ecomm_pname,
        ecomm_pcat,
        // ecomm_pvalue,
        ecomm_totalvalue
      })
    },

    trackOrderConfirmed ({ commit, state, getters, dispatch }, order) {
      if (!process.env.ALLOW_TRACKING) {
        console.log('tracking disallowed, ignoring order confirmed')
        return
      }
      if (!state.isLoaded) {
        dispatch('initializeTracking')
      }

      try {
        let orderTotalIncVat = getters.grandTotal
        let orderVAT = getters.vat
        let coupon = undefined
        if (getters.voucher.isValid === true) {
          coupon = getters.voucher.code
        }

        let products = []
        const ecomm_prodid = []
        const ecomm_pname = []
        const ecomm_pcat = []
        const ecomm_pvalue = []
        let ecomm_totalvalue = 0
        getters.cartItems.forEach(function (item) {
          let category = 'Posters'
          if (item.product) {
            switch(item.product.category) {
              case 'poster':
                category = 'Posters'
                break
              case 'giftCard':
                category = 'Gift Cards'
                break
              case 'frame':
              case 'hanger':
                category = 'Frames and Hangers'
                break
              default:
                category = 'Other'
            }
          }
          let variant = item.product ? item.product.variant : ''
          if (category === 'Posters') {
            variant = item.options ? item.options.color : item.color
          }
          const productObj = {
            name: item.product ? item.product.name : item.productName,
            id: item.product ? item.product.id : item.id,
            price: item.price.amount / 100,
            brand: item.product ? item.product.brand : getters.postersMetaData[item.productIdentifier].artist,
            category: category,
            variant: variant,
            quantity: item.count
          }
          products.push(productObj)
          ecomm_prodid.push(productObj.id)
          ecomm_pname.push(productObj.name)
          if (ecomm_pcat.indexOf(productObj.category) < 0) {
            ecomm_pcat.push(category)
          }
          ecomm_pvalue.push(productObj.price)
          ecomm_totalvalue += productObj.price * productObj.quantity
        })

        dataLayer.push({
          event: 'purchase',
          ecommerce: {
            currencyCode: getters.currency.currency,
            purchase: {
              actionField: {
                id: order.referenceNumber,
                // affiliation: 'Online Store',
                revenue: orderTotalIncVat / 100,
                tax: orderVAT / 100,
                shipping: order.shipping.costIncVat / 100,
                coupon: coupon
              },
              products
            }
          },
          customerEmail: order.customer.email,
          ecomm_pagetype: 'purchase',
          ecomm_prodid,
          ecomm_pname,
          ecomm_pcat,
          // ecomm_pvalue,
          ecomm_totalvalue,
          gcrDeliveryCountry: order.shipping.address.countryCode,
          gcrEstimatedDeliveryDate: new Date().toISOString().split('T')[0]
        })
      } catch (e) {
        console.log('tracking: order confirmed:', e)
      }
    },

    googleCustomerReviews ({ }, data) {
      window.renderOptIn = function() {
        window.gapi.load('surveyoptin', function() {
          window.gapi.surveyoptin.render({
            // REQUIRED FIELDS
            "merchant_id": 127109021,
            "order_id": data.orderRefNo,
            "email": data.email,
            "delivery_country": data.countryCode,
            "estimated_delivery_date": data.deliveryDate,
            // "products": [{"gtin":"GTIN1"}, {"gtin":"GTIN2"}]
          })
        })
      }
    }
  },

  getters: {
    trackingDomain (state, getters) {
      return 'com'
    },
    gtmID (state, getters) { return gtmNames[getters.trackingDomain] }
  }
}



// WEBPACK FOOTER //
// ./src/stores/tracking.js